export default {
    pullingText: 'Pull down to refresh ..',
    loosingText: 'Release to refresh...',
    loadingText: 'Loading...',
    errorName: 'Error Name',
    illustration: 'Image',
    errorCode: 'Error Code',
    loadMore: 'Load More',
    emptyTxt: 'No more data',
}
